import * as GmapVue from 'gmap-vue';
import VTooltip from 'v-tooltip';
import VueScrollTo from 'vue-scrollto';
import Vue from 'vue';
import Toasted from 'vue-toasted';
import * as VueMask from 'v-mask';
import breakpoints from '@/assets/styles/_variables.scss';
import highlight from '@/directives/highlight/highlight';
import themesPlugin from '@/plugins/themes/themesPlugin';
import saveable2 from '@/plugins/saveable/saveable2';
import confirmDialog from '@/plugins/confirmDialog';
import { VueSvgIcon } from '@yzfe/vue-svgicon';
import Hotjar from 'vue-hotjar';
import touch from '@/directives/touch/touch';
import { useAxios, useEventSystemAxios, useStaticAxios } from '@/axios/axios';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import './registerServiceWorker';
import 'normalize.css';
import validator from './directives/validator/validator';
import swipe from './directives/swipe/swipe';
import saveablePlugin from './plugins/saveable/saveableSupport';
import 'core-js/stable';

import '@/assets/styles/_icon.scss';

Vue.config.performance = process.env.NODE_ENV !== 'production';
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.productionTip = false;

Vue.directive('touch', touch);
Vue.directive('validator', validator);
Vue.directive('swipe', swipe);
Vue.directive('highlight', highlight);
Vue.directive('mask', (el, bind) => {
  // Check the binding value before applying the mask since the mask-directive doesn't ignore falsy values
  if (bind.value) {
    VueMask.VueMaskDirective.bind(el, bind);
  }
});

Vue.prototype.$axios = useAxios();
Vue.prototype.$staticAxios = useStaticAxios();
Vue.prototype.$eventSystemAxios = useEventSystemAxios();

Vue.use(Hotjar, {
  id: '1122109',
});
Vue.use(Toasted, {
  position: 'bottom-right',
});
Vue.use(saveable2);
Vue.use(confirmDialog);
Vue.use(saveablePlugin);
Vue.prototype.$breakpoints = breakpoints;
Vue.use(themesPlugin);
Vue.use(VTooltip);

Vue.use(GmapVue, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API_TOKEN,
    libraries: 'places',
    region: 'SE',
    language: 'sv',
  },
  installComponents: true,
});
Vue.use(VueScrollTo);

store.$axios = Vue.prototype.$axios;

Vue.component('SvgIcon', VueSvgIcon);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
